import axios from "axios";
import { url, newApiBaseUrl } from "../../axiosInstance";
import * as actionType from "../store/action";

export const LOCATION_ID = "678430";

export const getCart = (stationId) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        `${newApiBaseUrl}/carts/me?branch=${LOCATION_ID}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `bearer ${localStorage.jwtToken}`,
            "X-Tenant": "hamazon",
          },
        },
      );

      if (data) {
        dispatch({ type: actionType.SET_ALL_PRODUCT, payload: data });
        dispatch({ type: actionType.SET_DELIVERY_PRICE, payload: data });
      }
    } catch (err) {
      console.error("getCart error:", err);
    }
  };
};

export const CollectSiteProductSetOrder = (orderId) => {
  return (dispatch) => {
    axios
      .get(`${url}CollectSite/CollectSiteProductSetOrder?orderId=${orderId}`, {
        headers: {
          Authorization: `bearer ${localStorage.token}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((x) => {
        if (x.data) {
          dispatch({ type: actionType.SET_ALL_PRODUCT, payload: x.data });
        }
      });
  };
};

export const upsertCartItem = (
  productId,
  unitPrice,
  quantity,
  stationId,
  promoId = undefined,
) => {
  return (dispatch, getState) => {
    const val = {
      quantity,
      unitPrice: Number(unitPrice),
      branch: LOCATION_ID,
      // promoId: TODO:handle promoId here
    };
    axios
      .put(`${newApiBaseUrl}/carts/me/item/${productId}`, val, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
      })
      .then(async (x) => {
        if (
          x.data.revalidatedItems &&
          Object.keys(x.data.revalidatedItems).length > 0
        ) {
          //TODO: check if revalidated and updated items
          dispatch({
            type: actionType.SET_REVALIDATED_PRODUCTS,
            payload: { data: x.data, quantity, productId },
          });
        } else {
          dispatch({
            type: actionType.ADD_PRODUCT_IN_CART,
            payload: { data: x.data, quantity, productId },
          });
        }
        dispatch({ type: actionType.SET_DELIVERY_PRICE, payload: x.data });
      })
      .catch((x) => {
        if (x.response && x.response.status === 409) {
          dispatch({
            type: actionType.ADD_PRODUCT_IN_CART,
            payload: { data: x.response, quantity, productId },
          });
        } else {
          console.error("Error in upsertCartItem:", x);
        }
      });
  };
};
export const CancelError = () => {
  return (dispatch) => {
    dispatch({ type: actionType.CANCEL_ERROR });
  };
};

export const clearCart = () => {
  return (dispatch) => {
    dispatch({ type: actionType.CLEAR_CARD });
  };
};
